// extracted by mini-css-extract-plugin
module.exports = {"goLink":"go_goLink__GsAbo"};